const API_URL = (import.meta.env.VITE_PROSPECTOR_API_URL as string | undefined)?.replace(/\/$/, '');
export const isDemo = !API_URL;
const token = () => sessionStorage.getItem('prospector_token');
export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  if (!API_URL) throw new Error('API is not configured');
  const response = await fetch(`${API_URL}${path}`, { ...init, headers: { 'content-type': 'application/json', authorization: `Bearer ${token()}`, ...init.headers } });
  const body = await response.json(); if (!response.ok) throw new Error(body.error ?? 'Request failed'); return body.data as T;
}
